import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FormDraft {
  id: string;
  formType: string;
  data: any;
  timestamp: number;
}

interface DraftsState {
  drafts: FormDraft[];
}

// Helper function to check if user is SuperAdmin
const isSuperAdmin = (): boolean => {
  try {
    const userData = localStorage.getItem('user');
    if (!userData) return false;
    const user = JSON.parse(userData);
    return user?.roles?.includes('SuperAdmin') || false;
  } catch (error) {
    console.error('Error checking SuperAdmin role:', error);
    return false;
  }
};

const loadDraftsFromStorage = () => {
  // Only load drafts if user is SuperAdmin
  if (!isSuperAdmin()) return [];
  
  try {
    const storedDrafts = localStorage.getItem('formDrafts');
    console.log('Loading drafts on app init:', storedDrafts);
    return storedDrafts ? JSON.parse(storedDrafts) : [];
  } catch (error) {
    console.error('Error loading drafts from storage:', error);
    return [];
  }
};

const initialState: DraftsState = {
  drafts: loadDraftsFromStorage()
};

export const draftsSlice = createSlice({
  name: 'drafts',
  initialState,
  reducers: {
    saveDraft: (state, action: PayloadAction<FormDraft>) => {
      // Only save draft if user is SuperAdmin
      if (!isSuperAdmin()) return;
      
      console.log('Saving draft to store:', action.payload);
      const index = state.drafts.findIndex(d => 
        d.id === action.payload.id && d.formType === action.payload.formType
      );
      if (index !== -1) {
        state.drafts[index] = action.payload;
      } else {
        state.drafts.push(action.payload);
      }
      localStorage.setItem('formDrafts', JSON.stringify(state.drafts));
      console.log('Updated drafts in storage:', state.drafts);
    },
    removeDraft: (state, action: PayloadAction<{ id: string, formType: string }>) => {
      // Only remove draft if user is SuperAdmin
      if (!isSuperAdmin()) return;
      
      state.drafts = state.drafts.filter(d => 
        !(d.id === action.payload.id && d.formType === action.payload.formType)
      );
      localStorage.setItem('formDrafts', JSON.stringify(state.drafts));
    },
    clearAllDrafts: (state) => {
      // Only clear drafts if user is SuperAdmin
      if (!isSuperAdmin()) return;
      
      state.drafts = [];
      localStorage.removeItem('formDrafts');
    }
  }
});

export const { saveDraft, removeDraft, clearAllDrafts } = draftsSlice.actions;
export default draftsSlice.reducer;